import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {EiImportService} from '../../../../../../ei/service/api/ei-import.service';
import {EiImportDto} from '../../../../../../ei/model/dto/entity/ei-import.dto';
import {getEiImportPhaseLabel} from '../../../../../../ei/enum/ei-import-phase.enum';

/**
 * Shared EI-Import progress component for the HgImport OBC.
 *
 * Lazy-loads the referenced EiImport via EiImportService and renders the
 * ingestion counters (recordsCreated / recordsUpdated / recordsErrors /
 * recordsSkipped) plus the current phase. If no EiImport is linked, a friendly
 * info message is displayed instead.
 */
@Component({
    selector: 'hg-import-ei-progress',
    templateUrl: './hg-import-ei-progress.component.html',
    standalone: false
})
export class HgImportEiProgressComponent implements OnInit, OnChanges {

    @Input() eiImportId: number;
    @Input() eiImportName: string;

    @Output() onOpenEiImport: EventEmitter<void> = new EventEmitter<void>();

    initialized: boolean = false;
    loading: boolean = false;
    loadError: boolean = false;
    eiImport: EiImportDto | null = null;

    // @ticket TM-1000001829 — render the German phase uiLabel instead of the raw ordinal.
    protected readonly getEiImportPhaseLabel = getEiImportPhaseLabel;

    constructor(protected eiImportService: EiImportService) {
    }

    ngOnInit(): void {
        this.initialized = true;
        this.loadEiImport();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.initialized) {
            return;
        }
        if (changes['eiImportId']) {
            this.loadEiImport();
        }
    }

    private loadEiImport(): void {
        if (!this.eiImportId) {
            this.eiImport = null;
            this.loadError = false;
            return;
        }
        this.loading = true;
        this.loadError = false;
        this.eiImportService.get(this.eiImportId).subscribe({
            next: (res) => {
                this.eiImport = res as EiImportDto;
                this.loading = false;
            },
            error: () => {
                this.eiImport = null;
                this.loading = false;
                this.loadError = true;
            }
        });
    }

    handleOpenEiImport(): void {
        this.onOpenEiImport.emit();
    }
}
